import { render, staticRenderFns } from "./ChecklistFloatFieldModule.vue?vue&type=template&id=b1d98a08&scoped=true"
import script from "./ChecklistFloatFieldModule.vue?vue&type=script&lang=ts"
export * from "./ChecklistFloatFieldModule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d98a08",
  null
  
)

export default component.exports